import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Button from '../../../../components/button';
import Icon from '../../../../components/icon';
import Input from '../../../../components/input';
import {useDispatch, useSelector} from "react-redux";
import {
	isAddingNewCustomField as setIsAddingNewCustomField,
	submitCustomField as setSubmitCustomField,
	postNewCustomField
} from '../../../../../actions/customFieldsActions';
import CustomField from "./components/custom-field";
import Loader from '../../../../components/sprite/components/loader';
import {sharingPageReady} from '../../../../../actions/profileActions';
import CustomFieldDetails from './components/custom-field-details';
import AccessDeniedPage from '../../../../components/access-denied-page';
import CustomFieldDeletionConfirmationPopup
	from '../../../../components/popup/components/custom-field-deletion-confirmation-popup';
import CustomFieldDeletionErrorPopup from '../../../../components/popup/components/custom-field-deletion-error-popup';
import './index.css';

function CustomFieldsManager () {

	const [newRowValue, setNewRowValue] = useState("");

	const customFields = useSelector( state => state.customFieldsReducer.customFields);
	const isAddingNewCustomField = useSelector( state => state.customFieldsReducer.isAddingNewCustomField);
	const submitCustomField = useSelector( state => state.customFieldsReducer.submitCustomField);
	const customFieldDeletionConfirmationPopup = useSelector( state => state.customFieldsReducer.customFieldDeletionConfirmationPopup);
	const customFieldDeletionErrorPopup = useSelector( state => state.customFieldsReducer.customFieldDeletionErrorPopup);
	const profile = useSelector( state => state.profileReducer.getProfile);

	const dispatch = useDispatch();

	const {t} = useTranslation();

	useEffect(() => {
		dispatch(sharingPageReady(true));
	}, [dispatch]);

	const handleAddRow = () => {
		dispatch(setIsAddingNewCustomField(true));
	};

	/*const handleKeyPress = (e, index) => {
		if (e.which === 13) {
			let cTarget = e.target;
			setAddedRows((array) => {
				array[index] = cTarget.value;
				return array;
			});
			if(cTarget.value !== ""){
				setEditRow(0);
				setDisableAddRow(false);
			}

		}
	};*/

	const handleChangeNewRowValue = (e) => {
		setNewRowValue(e.target.value);
	};

	const handleClick = () => {
		dispatch(postNewCustomField(newRowValue));
		dispatch(setSubmitCustomField("add"));
		setNewRowValue("");
	};

	const handleCancel = () => {
		dispatch(setIsAddingNewCustomField(false));
		setNewRowValue("");
	};

	if(profile.domain.gsuiteDomain){
		if (profile.role === "ADMINISTRATOR") {
			return (
				<div className="custom-fields-manager p-5">
					{
						customFieldDeletionConfirmationPopup && <CustomFieldDeletionConfirmationPopup id={customFieldDeletionConfirmationPopup} />
					}
					{
						customFieldDeletionErrorPopup && <CustomFieldDeletionErrorPopup data={customFieldDeletionErrorPopup} />
					}
					<h2>{t('customFieldsManagerTitle')}</h2>
					{
						customFields
						?
							<div className="row">
								<div className="col-lg-6 mb-4 mb-lg-0">
									<div className="custom-fields">
										{
											customFields.message && !customFields.customFields
												?
												<p>{customFields.message}</p>
												:
												customFields.customFields.map((customField) => {
													return (
														<CustomField key={customField.id} item={customField}/>
													)
												})
										}
									</div>
									{
										isAddingNewCustomField && <div className="my-4 custom-field">
											<Input type={"text"} disabled={submitCustomField === "add"}
												   onChange={handleChangeNewRowValue}/>
										</div>
									}
									{
										customFields.customFields && (
											!isAddingNewCustomField
												?
												<Button onClick={handleAddRow} className="btn-primary">
													{t('customFieldsManagerAddBtn')}
												</Button>
												: submitCustomField === "add"
													?
													<Button disabled={true} className="btn-primary">
														<Icon animated={'pulse'} name="spinner"/>
													</Button>
													:
													<>
														<Button onClick={handleClick} disabled={newRowValue === ""}
																className="btn-primary mr-2">
															{t("textSave")}
														</Button>
														<Button onClick={handleCancel} className="btn-outline-primary">
															{t("textCancel")}
														</Button>
													</>
										)
									}
								</div>
								<div className="col-lg-6">
									<CustomFieldDetails/>
								</div>
							</div>
						:
							<div>
								<Loader/>
							</div>
					}

				</div>
			)
		} else {
			return (
				<AccessDeniedPage/>
			)
		}
	} else {
		return (
			<div className="custom-fields-manager p-5 text-center">
				Only Google Workspace users can access Custom Fields feature.
			</div>
		)
	}
}

export default CustomFieldsManager;
